import { Injectable } from "@angular/core";
import { Observable, of, from } from "rxjs";
import { environment } from "environments/environment";
import { Config } from "app/core/config";


@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  config: Config;
  private configPromise: Promise<Config> | null = null;

  constructor() {
  }

  public getConfigAsync(): Observable<Config> {
    if (this.config) {
      return of(this.config);
    }

    if (this.configPromise) {
      return from(this.configPromise);
    }

    this.configPromise = fetch(environment.configLocation)
      .then((response) => response.json())
      .then((data) => {
        this.config = data;
        return this.config;
      });

    return from(this.configPromise);
  }
}